
// DEPRECATED: This file is maintained for backwards compatibility
// Please use the new AuthContext from src/auth/context/AuthContext instead

import { AuthProvider as NewAuthProvider, useAuth as useNewAuth } from '@/auth/context/AuthContext';

// Re-export the components and hooks to maintain backwards compatibility
export const AuthProvider = NewAuthProvider;
export const useAuth = useNewAuth;

// Export all types from the new AuthContext
export * from '@/auth/context/AuthContext';
